import type { KeyLike } from './shortcutKeymap';
import { MUTATING_ACTIONS, type ActionId } from './shortcutKeymap';

/** `'block'` swallows the key silently (a mutating action during the
 * history preview); `'pass'` lets Lane A dispatch the action (or, with no
 * `actionId`, do nothing) as normal. */
export type LaneAGateResult = 'block' | 'pass';

export interface LaneAGateArgs {
    historyOpen: boolean;
    actionId: ActionId | null;
}

/**
 * Pure Lane A gate: the history-preview rule that must run before a
 * matched action ever dispatches.
 */
export const gateLaneAKey = (e: KeyLike, { historyOpen, actionId }: LaneAGateArgs): LaneAGateResult => {
    if (actionId && historyOpen && MUTATING_ACTIONS.has(actionId)) return 'block';
    return 'pass';
};
